import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Channel } from '../common/chat/models'
import { useChatStore } from '../common/chat/useChatData'
import ChannelInfo from './ChannelInfo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelsList',
  props: {
    channels: { default: () => [] }
  },
  emits: ["channel-clicked"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'channel-clicked', channel: any)
}), expose: any, slots: any, attrs: any }) {





const store = useChatStore()

const noSearchText = computed(() => {
  return store.searchText && store.searchText !== ''
})

const channelClicked = ({ documentId, group, unsubscribed }) => {
  emits('channel-clicked', { documentId, group, unsubscribed })
}

return { __sfc: true,emits, store, noSearchText, channelClicked, ChannelInfo }
}

})